<template>
  <b-modal title="Informações do Consumível" v-model="show" size="lg">
    <b-container fluid>
      <b-row class="mt-2">
        <b-col cols="11">
          <b-form-group label="Descrição:" label-for="descricao" label-cols-sm="3" label-align-sm="right">
            <b-form-input id="descricao" v-model="editing.descricao" />
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="mt-2">
        <b-col cols="11">
          <b-form-group label="Fabricante:" label-for="fabricante" label-cols-sm="3" label-align-sm="right">
            <b-form-input id="fabricante" v-model="editing.fabricante" />
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="mt-2">
        <b-col cols="11">
          <b-form-group label="Tipo:" label-for="tipo" label-cols-sm="3" label-align-sm="right">
            <b-form-input id="tipo" v-model="editing.tipo" />
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="mt-2">
        <b-col cols="11">
          <b-form-group label="Cor:" label-for="cor" label-cols-sm="3" label-align-sm="right">
            <b-form-input id="cor" v-model="editing.cor" />
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="mt-2">
        <b-col cols="11">
          <b-form-group label="Concetração:" label-for="concentracao" label-cols-sm="3" label-align-sm="right">
            <b-form-input id="cor" v-model="editing.concentracao" />
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="mt-2">
        <b-col cols="11">
          <b-form-group label="Veículo:" label-for="veiculo" label-cols-sm="3" label-align-sm="right">
            <b-form-input id="veiculo" v-model="editing.veiculo" />
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="mt-2">
        <b-col cols="11">
          <b-form-group label="Lote:" label-for="lote" label-cols-sm="3" label-align-sm="right">
            <b-form-input id="lote" v-model="editing.lote" />
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="11">
          <b-form-group label-cols-sm="3" label="Data:" label-align-sm="right" label-for="data">
            <b-form-datepicker
              id="data"
              v-model="editing.data"
              :date-format-options="{
                year: 'numeric',
                month: 'numeric',
                day: 'numeric',
              }"
            ></b-form-datepicker>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="11">
          <b-form-group label-cols-sm="3" label="Validade:" label-align-sm="right" label-for="data">
            <b-form-datepicker
              id="validade"
              v-model="editing.validade"
              :date-format-options="{
                year: 'numeric',
                month: 'numeric',
                day: 'numeric',
              }"
            ></b-form-datepicker>
          </b-form-group>
        </b-col>
      </b-row>
    </b-container>

    <template #modal-footer>
      <b-button variant="primary" @click="salvar()">Salvar</b-button>
      <b-button variant="secondary" @click="show = !show">Fechar</b-button>
    </template>
  </b-modal>
</template>

<script>
import Consumivel from "@/models/Consumivel";
import Notificacao from "@/models/Notificacao";
import { useSgcqStore } from "@/stores/SgcqStore";
import { useConsumivelStore } from "@/stores/ConsumivelStore";

export default {
  name: "ModalDeEdicaoDeConsumivel",

  data() {
    return {
      editing: new Consumivel(),
      show: false,
    };
  },

  methods: {
    salvar() {
      if (this.editing.id != 0) {
        this.consumivelStore.ALTERAR_CONSUMIVEL(this.editing).then(() => {
          this.store.NOTIFICAR(new Notificacao("Consumível salvo no SGCQ com sucesso!", "Excelente!", "success"));
        });
      } else {
        this.consumivelStore
          .CADASTRAR_CONSUMIVEL(this.editing)
          .then(() => this.store.NOTIFICAR(new Notificacao("Consumível salvo no SGCQ com sucesso!", "Excelente!", "success")));
      }
      this.show = !this.show;
    },

    call(consumivel) {
      this.editing = consumivel;
      this.show = !this.show;
    },
  },

  setup() {
    const store = useSgcqStore();
    const consumivelStore = useConsumivelStore();

    return {
      store,
      consumivelStore,
    };
  },
};
</script>

<style lang="scss" scoped></style>
